import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"13px","margin-top":"10px","color":"#414d4d"} }, "BÁO CÁO KẾT QUẢ HOẠT ĐỘNG KIỂM DỊCH Y TẾ HẰNG NGÀY", -1)
const _hoisted_2 = { class: "p-fluid" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Chọn loại báo cáo", -1)
const _hoisted_6 = { class: "p-field p-col-12 p-md-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Thời gian báo cáo: ", -1)
const _hoisted_8 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_11 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Tuần trong năm: ", -1)
const _hoisted_13 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Từ ngày: ", -1)
const _hoisted_15 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Đến ngày: ", -1)
const _hoisted_17 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_18 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Nhận xét, kiến nghị: ", -1)
const _hoisted_20 = { class: "p-fluid" }
const _hoisted_21 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_22 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_23 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Nhận xét, kiến nghị: ", -1)
const _hoisted_25 = { class: "p-fluid" }
const _hoisted_26 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_27 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_28 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Nhận xét, kiến nghị: ", -1)
const _hoisted_30 = { class: "p-fluid" }
const _hoisted_31 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_32 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_33 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Nhận xét, kiến nghị: ", -1)
const _hoisted_35 = { class: "p-fluid" }
const _hoisted_36 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_37 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_38 = { class: "p-fluid" }
const _hoisted_39 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_40 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_41 = { class: "p-fluid" }
const _hoisted_42 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_43 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_44 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Kết quả giám sát: ", -1)
const _hoisted_46 = { class: "p-fluid" }
const _hoisted_47 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_48 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_49 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", null, "Kết quả giám sát", -1)
const _hoisted_51 = { class: "p-fluid" }
const _hoisted_52 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_53 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_54 = { class: "p-fluid" }
const _hoisted_55 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_56 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_57 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"13px","margin-top":"10px","color":"#414d4d"} }, "BÁO CÁO KẾT QUẢ HOẠT ĐỘNG KIỂM DỊCH Y TẾ THÁNG", -1)
const _hoisted_59 = { class: "p-fluid" }
const _hoisted_60 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_61 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", null, "Từ ngày: ", -1)
const _hoisted_63 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", null, "Đến ngày: ", -1)
const _hoisted_65 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_66 = { class: "p-fluid" }
const _hoisted_67 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_68 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_69 = { class: "p-fluid" }
const _hoisted_70 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_71 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_72 = { class: "p-fluid" }
const _hoisted_73 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_74 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_75 = { class: "p-fluid" }
const _hoisted_76 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_77 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_78 = { class: "p-fluid" }
const _hoisted_79 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_80 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_81 = { class: "p-fluid" }
const _hoisted_82 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_83 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_84 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"13px","margin-top":"10px","color":"#414d4d"} }, "BÁO CÁO KẾT QUẢ HOẠT ĐỘNG KIỂM DỊCH Y TẾ TUẦN", -1)
const _hoisted_86 = { class: "p-fluid" }
const _hoisted_87 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_88 = { class: "p-field p-col-12 p-md-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", null, "Từ ngày: ", -1)
const _hoisted_90 = { class: "p-field p-col-12 p-md-2" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("label", null, "Đến ngày: ", -1)
const _hoisted_92 = { class: "p-field p-col-12 p-md-2" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", null, "Chọn năm: ", -1)
const _hoisted_94 = { class: "p-field p-col-12 p-md-2" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", null, "Chọn tuần", -1)
const _hoisted_96 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_97 = { class: "p-fluid" }
const _hoisted_98 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_99 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_100 = { class: "p-fluid" }
const _hoisted_101 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_102 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_103 = { class: "p-fluid" }
const _hoisted_104 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_105 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_106 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"13px","margin-top":"10px","color":"#414d4d"} }, "BÁO CÁO KẾT QUẢ HOẠT ĐỘNG KIỂM DỊCH Y TẾ 6 THÁNG", -1)
const _hoisted_108 = { class: "p-fluid" }
const _hoisted_109 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_110 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", null, "Từ ngày: ", -1)
const _hoisted_112 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", null, "Đến ngày: ", -1)
const _hoisted_114 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_115 = { class: "p-fluid" }
const _hoisted_116 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_117 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_118 = { class: "p-fluid" }
const _hoisted_119 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_120 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_121 = { class: "p-fluid" }
const _hoisted_122 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_123 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_124 = { class: "p-fluid" }
const _hoisted_125 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_126 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_127 = { class: "p-fluid" }
const _hoisted_128 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_129 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_130 = { class: "p-fluid" }
const _hoisted_131 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_132 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_133 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", null, "Kết quả giám sát", -1)
const _hoisted_135 = { class: "p-fluid" }
const _hoisted_136 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_137 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_138 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("label", null, "Kết quả giám sát", -1)
const _hoisted_140 = { class: "p-fluid" }
const _hoisted_141 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_142 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_143 = { class: "p-fluid" }
const _hoisted_144 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_145 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_146 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"13px","margin-top":"10px","color":"#414d4d"} }, "BÁO CÁO KẾT QUẢ HOẠT ĐỘNG KIỂM DỊCH Y TẾ NĂM", -1)
const _hoisted_148 = { class: "p-fluid" }
const _hoisted_149 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_150 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("label", null, "Từ ngày: ", -1)
const _hoisted_152 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", null, "Đến ngày: ", -1)
const _hoisted_154 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_155 = { class: "p-fluid" }
const _hoisted_156 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_157 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_158 = { class: "p-fluid" }
const _hoisted_159 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_160 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_161 = { class: "p-fluid" }
const _hoisted_162 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_163 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_164 = { class: "p-fluid" }
const _hoisted_165 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_166 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_167 = { class: "p-fluid" }
const _hoisted_168 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_169 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_170 = { class: "p-fluid" }
const _hoisted_171 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_172 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_173 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("label", null, "Kết quả giám sát", -1)
const _hoisted_175 = { class: "p-fluid" }
const _hoisted_176 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_177 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_178 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("label", null, "Kết quả giám sát", -1)
const _hoisted_180 = { class: "p-fluid" }
const _hoisted_181 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_182 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_183 = { class: "p-fluid" }
const _hoisted_184 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_185 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_186 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_187 = { class: "p-fluid" }
const _hoisted_188 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_189 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_190 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, null, {
      default: _withCtx(() => [
        _createVNode(_component_TabView, null, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, { header: "BÁO CÁO HẰNG NGÀY" }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_Accordion, {
                  activeIndex: 0,
                  style: {"margin-top":"3px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AccordionTab, { header: "1. Kết quả kiểm dịch y tế đối với người" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _hoisted_5,
                              _createVNode(_component_Dropdown, {
                                id: "permission",
                                modelValue: $setup.selection,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selection) = $event)),
                                options: $setup.listSelection,
                                optionLabel: "label",
                                optionValue: "param",
                                placeholder: "Vui lòng chọn loại báo cáo ..."
                              }, null, 8, ["modelValue", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _hoisted_7,
                              _createVNode(_component_Calendar, {
                                modelValue: $setup.baoCaoNgay.thoiGianBaoCao,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.baoCaoNgay.thoiGianBaoCao) = $event)),
                                touchUI: "",
                                view: "date",
                                onDateSelect: $setup.selectDay,
                                dateFormat: "dd/mm/yy"
                              }, null, 8, ["modelValue", "onDateSelect"])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_Panel, { header: "Tuần báo cáo" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createElementVNode("div", _hoisted_11, [
                                        _hoisted_12,
                                        _createElementVNode("label", null, _toDisplayString($setup.tuan.tuan), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_13, [
                                        _hoisted_14,
                                        _createElementVNode("label", null, _toDisplayString($setup.formatDateTime($setup.tuan.tuNgay)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_15, [
                                        _hoisted_16,
                                        _createElementVNode("label", null, _toDisplayString($setup.formatDateTime($setup.tuan.denNgay)), 1)
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNgay.cuaKhauDoiVoiNguois.filter(x => (($setup.selection == 1)&&(x.id <= 6))||(($setup.selection == 2)&&(x.id > 6)&&(x.id < 13))||($setup.selection == 0)),
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra (lượt)",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số phải xử lý y tế và áp dụng biện pháp dự phòng (lượt)",
                                            rowspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Tổng số",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số nghi ngờ, mắc bệnh",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.tongSo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soNghiNgo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNghiNgo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soXuLyYTe,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soXuLyYTe) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu2",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNgay.nhanXetVoiNguoi,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.baoCaoNgay.nhanXetVoiNguoi) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "2. Kết quả kiểm dịch y tế phương tiện" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNgay.cuaKhauPhuongTiens.filter(x => (($setup.selection == 1)&&(x.id <= 6))||(($setup.selection == 2)&&(x.id > 6)&&(x.id < 13))||($setup.selection == 0)),
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện hàng không (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường bộ (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường thủy (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường sắt (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(12)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(13)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(14)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNgay.nhanXetVoiPhuongTien,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.baoCaoNgay.nhanXetVoiPhuongTien) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "3. Kết quả kiểm dịch y tế đối với hàng hóa" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNgay.cuaKhauHangHoas.filter(x => (($setup.selection == 1)&&(x.id <= 6))||(($setup.selection == 2)&&(x.id > 6)&&(x.id < 13))||($setup.selection == 0)),
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Bưu phẩm/ Bưu kiện (gói/kiện)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Hàng hóa khác (tấn)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Trọng lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu3",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNgay.nhanXetVoiHangHoa,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.baoCaoNgay.nhanXetVoiHangHoa) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "4. Kết quả kiểm dịch y tế đối với thi thể, hài cốt, tro cốt" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNgay.cuaKhauThiThes.filter(x => (($setup.selection == 1)&&(x.id <= 6))||(($setup.selection == 2)&&(x.id > 6)&&(x.id < 13))||($setup.selection == 0)),
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Thi thể",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Hài cốt",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tro cốt",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu4",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _hoisted_34,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNgay.nhanXetVoiHaiCot,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.baoCaoNgay.nhanXetVoiHaiCot) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "5. Kết quả kiểm dịch y tế đối với mẫu vi sinh y học, sản phẩm sinh học, mô, bộ phận cơ  thể người" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNgay.cuaKhauViSinhs.filter(x => (($setup.selection == 1)&&(x.id <= 6))||(($setup.selection == 2)&&(x.id > 6)&&(x.id < 13))||($setup.selection == 0)),
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mẫu vi sinh y học (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Sản phẩm sinh học (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mô, bộ phận cơ thể người (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu5",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "6. Tiêm chủng (gồm cả tiêm chủng dịch vụ)" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_Toolbar, { class: "mb-6" }, {
                                start: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    severity: "secondary",
                                    icon: "pi pi-plus",
                                    class: "mr-2",
                                    onClick: $setup.addTiemChungNgay
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNgay.tiemChungs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Tên bệnh",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "tenBenh",
                                        type: "text",
                                        modelValue: slotProps.data.tenBenh,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenBenh) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Tên Vắc xin"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "tenVacxin",
                                        type: "text",
                                        modelValue: slotProps.data.tenVacxin,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenVacxin) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: "Số lượng người được sử dụng"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.soLuongNguoi,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongNguoi) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: "Ghi chú"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "7. Giám sát dịch bệnh tại khu vực cửa khẩu" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_Toolbar, { class: "mb-6" }, {
                                start: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    severity: "secondary",
                                    icon: "pi pi-plus",
                                    class: "mr-2",
                                    onClick: $setup.addGiamSatNgay
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNgay.giamSatDichBenhs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 3,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Giám sát véc tơ, trung gian truyền bệnh",
                                            colspan: 6
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Giám sát vệ sinh an toàn thực phẩm",
                                            colspan: 4
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Mật độ chuột",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Chỉ số bọ chét",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mật độ muỗi",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng cơ sở dịch vụ đã được giám sát (nhà hàng, khách sạn...)",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng cơ sở sản xuất, chế biến, cung ứng thực phẩm đã được giám sát",
                                            colspan: 2
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lần giám sát",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần giám sát",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần giám sát",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Đạt tiêu chuẩn",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Không đạt",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Đạt tiêu chuẩn",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Không đạt",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "tenCuaKhau",
                                        type: "text",
                                        modelValue: slotProps.data.tenCuaKhau,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenCuaKhau) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoChuot.soLanGiamSat,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoChuot.soLanGiamSat) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoChuot.soLanXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoChuot.soLanXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.chiSoBoChet.soLanGiamSat,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiSoBoChet.soLanGiamSat) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.chiSoBoChet.soLanXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiSoBoChet.soLanXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoMuoi.soLanGiamSat,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoMuoi.soLanGiamSat) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoMuoi.soLanXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoMuoi.soLanXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongDVDaDuocGiamSat.datTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongDVDaDuocGiamSat.datTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongDVDaDuocGiamSat.khongDatTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongDVDaDuocGiamSat.khongDatTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongCoSoSanXuat.datTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongCoSoSanXuat.datTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongCoSoSanXuat.khongDatTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongCoSoSanXuat.khongDatTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _hoisted_45,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNgay.ketQuaGiamSat,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.baoCaoNgay.ketQuaGiamSat) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "8. Xét nghiệm" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_Toolbar, { class: "mb-6" }, {
                                start: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    severity: "secondary",
                                    icon: "pi pi-plus",
                                    class: "mr-2",
                                    onClick: $setup.addXetNghiemNgay
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNgay.xetNghiems,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Loại xét nghiệm",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "loaiXetNghiem",
                                        type: "text",
                                        modelValue: slotProps.data.loaiXetNghiem,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiXetNghiem) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Số lượng mẫu"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.soLuongMau,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongMau) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: "Số lượng người được sử dụng"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.soLuongNguoi,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongNguoi) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Đạt tiêu chuẩn (%)"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.datTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.datTieuChuan) = $event),
                                        suffix: "%"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Ghi chú",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu2",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _hoisted_50,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNam.ketQuaGiamSatXetNghiem,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.baoCaoNam.ketQuaGiamSatXetNghiem) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "9. Các hoạt động khác" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNgay.cacHoatDongKhac,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.baoCaoNgay.cacHoatDongKhac) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "10. Nhận xét, kiến nghị chung" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNgay.nhanXet,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.baoCaoNgay.nhanXet) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createVNode(_component_Button, {
                                label: "Gởi báo cáo",
                                icon: "pi pi-upload",
                                severity: "secondary",
                                raised: "",
                                onClick: $setup.addReportDay
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, { header: "BÁO CÁO THÁNG" }, {
              default: _withCtx(() => [
                _hoisted_58,
                _createVNode(_component_Accordion, {
                  activeIndex: 0,
                  style: {"margin-top":"3px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AccordionTab, { header: "1. Kết quả kiểm dịch y tế đối với người:" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createVNode(_component_Calendar, {
                                modelValue: $setup.baoCao.tuNgay,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.baoCao.tuNgay) = $event)),
                                touchUI: "",
                                view: "date",
                                dateFormat: "dd/mm/yy"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _hoisted_64,
                              _createVNode(_component_Calendar, {
                                modelValue: $setup.baoCao.denNgay,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.baoCao.denNgay) = $event)),
                                touchUI: "",
                                view: "date",
                                dateFormat: "dd/mm/yy"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao.cuaKhauDoiVoiNguois,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra (lượt)",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số phải xử lý y tế và áp dụng biện pháp dự phòng (lượt)",
                                            rowspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Tổng số",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số nghi ngờ, mắc bệnh",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.tongSo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soNghiNgo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNghiNgo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soXuLyYTe,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soXuLyYTe) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu2",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "2. Kết quả kiểm dịch y tế phương tiện" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao.cuaKhauPhuongTiens,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện hàng không (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường bộ (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường thủy (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường sắt (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(12)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(13)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(14)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "3. Kết quả kiểm dịch y tế đối với hàng hóa" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao.cuaKhauHangHoas,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Bưu phẩm/ Bưu kiện (gói/kiện)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Hàng hóa khác (tấn)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Trọng lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu3",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "4. Kết quả kiểm dịch y tế đối với thi thể, hài cốt, tro cốt" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao.cuaKhauThiThes,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Thi thể",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Hài cốt",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tro cốt",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu4",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "5. Kết quả kiểm dịch y tế đối với mẫu vi sinh y học, sản phẩm sinh học, mô, bộ phận cơ  thể người" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao.cuaKhauViSinhs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mẫu vi sinh y học (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Sản phẩm sinh học (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mô, bộ phận cơ thể người (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.sanPhamSinhHoc.soXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu5",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "6. Kết quả hoạt động khác" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCao.ketQua,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.baoCao.ketQua) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "7. Nhận xét" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCao.nhanXet,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.baoCao.nhanXet) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_84, [
                              _createVNode(_component_Button, {
                                label: "Gởi báo cáo",
                                icon: "pi pi-upload",
                                severity: "secondary",
                                raised: "",
                                onClick: $setup.addReport
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, { header: "BÁO CÁO TUẦN" }, {
              default: _withCtx(() => [
                _hoisted_85,
                _createVNode(_component_Accordion, {
                  activeIndex: 0,
                  style: {"margin-top":"3px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AccordionTab, { header: "1. Kết quả kiểm dịch y tế đối với người:" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                              _hoisted_89,
                              _createElementVNode("label", null, _toDisplayString($setup.formatDateTime($setup.baoCaoTuan.tuNgay)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _hoisted_91,
                              _createElementVNode("label", null, _toDisplayString($setup.formatDateTime($setup.baoCaoTuan.denNgay)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_92, [
                              _hoisted_93,
                              _createVNode(_component_Calendar, {
                                modelValue: $setup.dateYear,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.dateYear) = $event)),
                                touchUI: "",
                                view: "year",
                                dateFormat: "yy",
                                onDateSelect: _cache[15] || (_cache[15] = ($event: any) => ($setup.getListWeek()))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                              _hoisted_95,
                              _createVNode(_component_Dropdown, {
                                id: "permission",
                                modelValue: $setup.baoCaoTuan.id,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.baoCaoTuan.id) = $event)),
                                options: $setup.listWeek,
                                optionLabel: "id",
                                optionValue: "id",
                                placeholder: "Vui lòng chọn tuần...",
                                onFocus: $setup.selectWeek
                              }, null, 8, ["modelValue", "options", "onFocus"])
                            ]),
                            _createElementVNode("div", _hoisted_96, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoTuan.cuaKhauDoiVoiNguois,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra (lượt)",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số phải xử lý y tế và áp dụng biện pháp dự phòng (lượt)",
                                            rowspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Tổng số",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số nghi ngờ, mắc bệnh",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.tongSo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soNghiNgo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNghiNgo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soXuLyYTe,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soXuLyYTe) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu2",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "2. Kết quả kiểm dịch y tế phương tiện" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoTuan.cuaKhauPhuongTiens,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện hàng không (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường bộ (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường thủy (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường sắt (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(12)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(13)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(14)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.phuongTienDuongBo.soLuong,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soLuong) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.phuongTienDuongBo.soKiemTra,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soKiemTra) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.phuongTienDuongBo.soXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.phuongTienDuongThuy.soLuong,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soLuong) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.phuongTienDuongThuy.soKiemTra,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soKiemTra) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.phuongTienDuongThuy.soXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.phuongTienDuongSat.soLuong,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soLuong) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.phuongTienDuongSat.soKiemTra,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soKiemTra) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.phuongTienDuongSat.soXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "3. Kết quả hoạt động khác" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoTuan.ketQua,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.baoCaoTuan.ketQua) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "4. Kết luận" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("div", _hoisted_105, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoTuan.ketLuan,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.baoCaoTuan.ketLuan) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_106, [
                              _createVNode(_component_Button, {
                                label: "Gởi báo cáo",
                                icon: "pi pi-upload",
                                severity: "secondary",
                                raised: "",
                                onClick: $setup.addReportWeek
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, { header: "BÁO CÁO 6 THÁNG" }, {
              default: _withCtx(() => [
                _hoisted_107,
                _createVNode(_component_Accordion, {
                  activeIndex: 0,
                  style: {"margin-top":"3px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AccordionTab, { header: "1. Kết quả kiểm dịch y tế đối với người" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_108, [
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("div", _hoisted_110, [
                              _hoisted_111,
                              _createVNode(_component_Calendar, {
                                modelValue: $setup.baoCao6Thang.tuNgay,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.baoCao6Thang.tuNgay) = $event)),
                                touchUI: "",
                                view: "date",
                                dateFormat: "dd/mm/yy"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_112, [
                              _hoisted_113,
                              _createVNode(_component_Calendar, {
                                modelValue: $setup.baoCao6Thang.denNgay,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.baoCao6Thang.denNgay) = $event)),
                                touchUI: "",
                                view: "date",
                                dateFormat: "dd/mm/yy"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao6Thang.cuaKhauDoiVoiNguois,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra (lượt)",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số phải xử lý y tế và áp dụng biện pháp dự phòng (lượt)",
                                            rowspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Tổng số",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số nghi ngờ, mắc bệnh",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.tongSo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soNghiNgo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNghiNgo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soXuLyYTe,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soXuLyYTe) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu2",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "2. Kết quả kiểm dịch y tế phương tiện" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao6Thang.cuaKhauPhuongTiens,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện hàng không (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường bộ (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường thủy (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường sắt (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(12)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(13)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(14)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "3. Kết quả kiểm dịch y tế đối với hàng hóa" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("div", _hoisted_120, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao6Thang.cuaKhauHangHoas,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Bưu phẩm/ Bưu kiện (gói/kiện)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Hàng hóa khác (tấn)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Trọng lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu3",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "4. Kết quả kiểm dịch y tế đối với thi thể, hài cốt, tro cốt" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_121, [
                          _createElementVNode("div", _hoisted_122, [
                            _createElementVNode("div", _hoisted_123, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao6Thang.cuaKhauThiThes,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Thi thể",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Hài cốt",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tro cốt",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu4",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "5. Kết quả kiểm dịch y tế đối với mẫu vi sinh y học, sản phẩm sinh học, mô, bộ phận cơ  thể người" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_124, [
                          _createElementVNode("div", _hoisted_125, [
                            _createElementVNode("div", _hoisted_126, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao6Thang.cuaKhauViSinhs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mẫu vi sinh y học (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Sản phẩm sinh học (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mô, bộ phận cơ thể người (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu5",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "6. Tiêm chủng (gồm cả tiêm chủng dịch vụ)" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_127, [
                          _createElementVNode("div", _hoisted_128, [
                            _createElementVNode("div", _hoisted_129, [
                              _createVNode(_component_Toolbar, { class: "mb-6" }, {
                                start: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    severity: "secondary",
                                    icon: "pi pi-plus",
                                    class: "mr-2",
                                    onClick: $setup.addTiemChung
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao6Thang.tiemChungs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Tên bệnh",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "tenBenh",
                                        type: "text",
                                        modelValue: slotProps.data.tenBenh,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenBenh) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Tên Vắc xin"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "tenVacxin",
                                        type: "text",
                                        modelValue: slotProps.data.tenVacxin,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenVacxin) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: "Số lượng người được sử dụng"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.soLuongNguoi,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongNguoi) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: "Ghi chú"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "7. Giám sát dịch bệnh tại khu vực cửa khẩu" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_130, [
                          _createElementVNode("div", _hoisted_131, [
                            _createElementVNode("div", _hoisted_132, [
                              _createVNode(_component_Toolbar, { class: "mb-6" }, {
                                start: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    severity: "secondary",
                                    icon: "pi pi-plus",
                                    class: "mr-2",
                                    onClick: $setup.addGiamSat
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao6Thang.giamSatDichBenhs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 3,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Giám sát véc tơ, trung gian truyền bệnh",
                                            colspan: 6
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Giám sát vệ sinh an toàn thực phẩm",
                                            colspan: 4
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Mật độ chuột",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Chỉ số bọ chét",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mật độ muỗi",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng cơ sở dịch vụ đã được giám sát (nhà hàng, khách sạn...)",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng cơ sở sản xuất, chế biến, cung ứng thực phẩm đã được giám sát",
                                            colspan: 2
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lần giám sát",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần giám sát",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần giám sát",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Đạt tiêu chuẩn",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Không đạt",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Đạt tiêu chuẩn",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Không đạt",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "tenCuaKhau",
                                        type: "text",
                                        modelValue: slotProps.data.tenCuaKhau,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenCuaKhau) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoChuot.soLanGiamSat,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoChuot.soLanGiamSat) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoChuot.soLanXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoChuot.soLanXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.chiSoBoChet.soLanGiamSat,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiSoBoChet.soLanGiamSat) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.chiSoBoChet.soLanXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiSoBoChet.soLanXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoMuoi.soLanGiamSat,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoMuoi.soLanGiamSat) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoMuoi.soLanXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoMuoi.soLanXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongDVDaDuocGiamSat.datTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongDVDaDuocGiamSat.datTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongDVDaDuocGiamSat.khongDatTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongDVDaDuocGiamSat.khongDatTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongCoSoSanXuat.datTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongCoSoSanXuat.datTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongCoSoSanXuat.khongDatTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongCoSoSanXuat.khongDatTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_133, [
                              _hoisted_134,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCao6Thang.ketQuaGiamSat,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.baoCao6Thang.ketQuaGiamSat) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "8. Xét nghiệm" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", _hoisted_136, [
                            _createElementVNode("div", _hoisted_137, [
                              _createVNode(_component_Toolbar, { class: "mb-6" }, {
                                start: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    severity: "secondary",
                                    icon: "pi pi-plus",
                                    class: "mr-2",
                                    onClick: $setup.addXetNghiem
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCao6Thang.xetNghiems,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Loại xét nghiệm",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "loaiXetNghiem",
                                        type: "text",
                                        modelValue: slotProps.data.loaiXetNghiem,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiXetNghiem) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Số lượng mẫu"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.soLuongMau,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongMau) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: "Số lượng người được sử dụng"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.soLuongNguoi,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongNguoi) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Đạt tiêu chuẩn (%)"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.datTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.datTieuChuan) = $event),
                                        suffix: "%"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Ghi chú",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu2",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_138, [
                              _hoisted_139,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCao6Thang.ketQuaGiamSatXetNghiem,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.baoCao6Thang.ketQuaGiamSatXetNghiem) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "9. Các hoạt động khác" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", _hoisted_141, [
                            _createElementVNode("div", _hoisted_142, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCao6Thang.cacHoatDongKhac,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.baoCao6Thang.cacHoatDongKhac) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "10. Nhận xét, kiến nghị chung" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_143, [
                          _createElementVNode("div", _hoisted_144, [
                            _createElementVNode("div", _hoisted_145, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCao6Thang.nhanXet,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.baoCao6Thang.nhanXet) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_146, [
                              _createVNode(_component_Button, {
                                label: "Gởi báo cáo",
                                icon: "pi pi-upload",
                                severity: "secondary",
                                raised: "",
                                onClick: $setup.addReport6Month
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, { header: "BÁO CÁO NĂM" }, {
              default: _withCtx(() => [
                _hoisted_147,
                _createVNode(_component_Accordion, {
                  activeIndex: 0,
                  style: {"margin-top":"3px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AccordionTab, { header: "1. Kết quả kiểm dịch y tế đối với người" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_148, [
                          _createElementVNode("div", _hoisted_149, [
                            _createElementVNode("div", _hoisted_150, [
                              _hoisted_151,
                              _createVNode(_component_Calendar, {
                                modelValue: $setup.baoCaoNam.tuNgay,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.baoCaoNam.tuNgay) = $event)),
                                touchUI: "",
                                view: "date",
                                dateFormat: "dd/mm/yy"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_152, [
                              _hoisted_153,
                              _createVNode(_component_Calendar, {
                                modelValue: $setup.baoCaoNam.denNgay,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.baoCaoNam.denNgay) = $event)),
                                touchUI: "",
                                view: "date",
                                dateFormat: "dd/mm/yy"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_154, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNam.cuaKhauDoiVoiNguois,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra (lượt)",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số phải xử lý y tế và áp dụng biện pháp dự phòng (lượt)",
                                            rowspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Tổng số",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số nghi ngờ, mắc bệnh",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.tongSo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soNghiNgo,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNghiNgo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.soXuLyYTe,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soXuLyYTe) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu2",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "2. Kết quả kiểm dịch y tế phương tiện" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_155, [
                          _createElementVNode("div", _hoisted_156, [
                            _createElementVNode("div", _hoisted_157, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNam.cuaKhauPhuongTiens,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện hàng không (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường bộ (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường thủy (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Phương tiện đường sắt (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(12)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(13)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(14)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienHangKhong.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienHangKhong.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongBo.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongBo.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongThuy.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongThuy.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.phuongTienDuongSat.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phuongTienDuongSat.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "3. Kết quả kiểm dịch y tế đối với hàng hóa" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_158, [
                          _createElementVNode("div", _hoisted_159, [
                            _createElementVNode("div", _hoisted_160, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNam.cuaKhauHangHoas,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Bưu phẩm/ Bưu kiện (gói/kiện)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Hàng hóa khác (tấn)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Trọng lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.buuPham.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.buuPham.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.hangHoaKhac.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hangHoaKhac.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu3",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "4. Kết quả kiểm dịch y tế đối với thi thể, hài cốt, tro cốt" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_161, [
                          _createElementVNode("div", _hoisted_162, [
                            _createElementVNode("div", _hoisted_163, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNam.cuaKhauThiThes,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Thi thể",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Hài cốt",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tro cốt",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.thiThe.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.thiThe.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.haiCot.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.haiCot.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.troCot.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.troCot.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu4",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "5. Kết quả kiểm dịch y tế đối với mẫu vi sinh y học, sản phẩm sinh học, mô, bộ phận cơ  thể người" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_164, [
                          _createElementVNode("div", _hoisted_165, [
                            _createElementVNode("div", _hoisted_166, [
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNam.cuaKhauViSinhs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 2,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mẫu vi sinh y học (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Sản phẩm sinh học (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mô, bộ phận cơ thể người (lượt)",
                                            colspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Ghi chú",
                                            rowspan: 2,
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số kiểm tra",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số xử lý",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "(1)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(2)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(3)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(4)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(5)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(6)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(7)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(8)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(9)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(10)",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "(11)",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createElementVNode("label", null, _toDisplayString(slotProps.data.viTri), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.mauViSinh.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.mauViSinh.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.sanPhamSinhHoc.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.sanPhamSinhHoc.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soLuong,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soLuong) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soKiemTra,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soKiemTra) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soXuLyYTe",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      (slotProps.data.id%2 == 1)
                                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                                            key: 0,
                                            inputId: "integeronly",
                                            modelValue: slotProps.data.boPhanCoTheNguoi.soXuLy,
                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.boPhanCoTheNguoi.soXuLy) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongNuCoSo",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu5",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "6. Tiêm chủng (gồm cả tiêm chủng dịch vụ)" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_167, [
                          _createElementVNode("div", _hoisted_168, [
                            _createElementVNode("div", _hoisted_169, [
                              _createVNode(_component_Toolbar, { class: "mb-6" }, {
                                start: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    severity: "secondary",
                                    icon: "pi pi-plus",
                                    class: "mr-2",
                                    onClick: $setup.addTiemChungNam
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNam.tiemChungs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Tên bệnh",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "tenBenh",
                                        type: "text",
                                        modelValue: slotProps.data.tenBenh,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenBenh) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Tên Vắc xin"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "tenVacxin",
                                        type: "text",
                                        modelValue: slotProps.data.tenVacxin,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenVacxin) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: "Số lượng người được sử dụng"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.soLuongNguoi,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongNguoi) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soNghiNgo",
                                    header: "Ghi chú"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "7. Giám sát dịch bệnh tại khu vực cửa khẩu" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_170, [
                          _createElementVNode("div", _hoisted_171, [
                            _createElementVNode("div", _hoisted_172, [
                              _createVNode(_component_Toolbar, { class: "mb-6" }, {
                                start: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    severity: "secondary",
                                    icon: "pi pi-plus",
                                    class: "mr-2",
                                    onClick: $setup.addGiamSatNam
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNam.giamSatDichBenhs,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "TT",
                                            rowspan: 3
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Tên cửa khẩu",
                                            rowspan: 3,
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Giám sát véc tơ, trung gian truyền bệnh",
                                            colspan: 6
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Giám sát vệ sinh an toàn thực phẩm",
                                            colspan: 4
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Mật độ chuột",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Chỉ số bọ chét",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Mật độ muỗi",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng cơ sở dịch vụ đã được giám sát (nhà hàng, khách sạn...)",
                                            colspan: 2
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lượng cơ sở sản xuất, chế biến, cung ứng thực phẩm đã được giám sát",
                                            colspan: 2
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Số lần giám sát",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần giám sát",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần giám sát",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Số lần xử lý",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Đạt tiêu chuẩn",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Không đạt",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Đạt tiêu chuẩn",
                                            colspan: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            header: "Không đạt",
                                            colspan: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "tenCuaKhau",
                                        type: "text",
                                        modelValue: slotProps.data.tenCuaKhau,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tenCuaKhau) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoChuot.soLanGiamSat,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoChuot.soLanGiamSat) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoChuot.soLanXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoChuot.soLanXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.chiSoBoChet.soLanGiamSat,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiSoBoChet.soLanGiamSat) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.chiSoBoChet.soLanXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiSoBoChet.soLanXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoMuoi.soLanGiamSat,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoMuoi.soLanGiamSat) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.matDoMuoi.soLanXuLy,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.matDoMuoi.soLanXuLy) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongDVDaDuocGiamSat.datTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongDVDaDuocGiamSat.datTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongDVDaDuocGiamSat.khongDatTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongDVDaDuocGiamSat.khongDatTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongCoSoSanXuat.datTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongCoSoSanXuat.datTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: ""
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        inputId: "integeronly",
                                        modelValue: slotProps.data.soLuongCoSoSanXuat.khongDatTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongCoSoSanXuat.khongDatTieuChuan) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_173, [
                              _hoisted_174,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNam.ketQuaGiamSat,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.baoCaoNam.ketQuaGiamSat) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "8. Xét nghiệm" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_175, [
                          _createElementVNode("div", _hoisted_176, [
                            _createElementVNode("div", _hoisted_177, [
                              _createVNode(_component_Toolbar, { class: "mb-6" }, {
                                start: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    severity: "secondary",
                                    icon: "pi pi-plus",
                                    class: "mr-2",
                                    onClick: $setup.addXetNghiemNam
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DataTable, {
                                value: $setup.baoCaoNam.xetNghiems,
                                showGridlines: "",
                                rows: 40,
                                rowHover: true,
                                style: {"font-size":"14px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Loại xét nghiệm",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "loaiXetNghiem",
                                        type: "text",
                                        modelValue: slotProps.data.loaiXetNghiem,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiXetNghiem) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Số lượng mẫu"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.soLuongMau,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongMau) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongSo",
                                    header: "Số lượng người được sử dụng"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.soLuongNguoi,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongNguoi) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Đạt tiêu chuẩn (%)"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputNumber, {
                                        modelValue: slotProps.data.datTieuChuan,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.datTieuChuan) = $event),
                                        suffix: "%"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "",
                                    header: "Ghi chú",
                                    style: {"width":"350px"}
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createVNode(_component_InputText, {
                                        id: "ghiChu2",
                                        type: "text",
                                        modelValue: slotProps.data.ghiChu,
                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_178, [
                              _hoisted_179,
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNam.ketQuaGiamSatXetNghiem,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.baoCaoNam.ketQuaGiamSatXetNghiem) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "9. Các hoạt động khác" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_180, [
                          _createElementVNode("div", _hoisted_181, [
                            _createElementVNode("div", _hoisted_182, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNam.cacHoatDongKhac,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.baoCaoNam.cacHoatDongKhac) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AccordionTab, { header: "10. Nhận xét, kiến nghị chung" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_183, [
                          _createElementVNode("div", _hoisted_184, [
                            _createElementVNode("div", _hoisted_185, [
                              _createVNode(_component_Textarea, {
                                modelValue: $setup.baoCaoNam.nhanXet,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.baoCaoNam.nhanXet) = $event)),
                                rows: "10"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_186, [
                              _createVNode(_component_Button, {
                                label: "Gởi báo cáo",
                                icon: "pi pi-upload",
                                severity: "secondary",
                                raised: "",
                                onClick: $setup.addReportYear
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_187, [
      _createElementVNode("div", _hoisted_188, [
        _createElementVNode("div", _hoisted_189, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_190, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}